import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: 50,
    height: 50,
    backgroundColor: theme.palette.details,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rootAvatar: {
    width: 48,
    height: 48,
    backgroundColor: theme.palette.details,
    borderRadius: '50%',
    overflow: 'hidden',
    paddingTop: 4,
  },
  rootAvatarEditable: {
    width: 48,
    height: 48,
    backgroundColor: theme.palette.details,
    borderRadius: '50%',
    overflow: 'hidden',
    paddingTop: 4,
    transition: 'all 200ms ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    '& > div': {
      transition: 'all 200ms ease-in-out',
      transform: 'translateY(0px)',
    },
    '&:hover > div': {
      transition: 'all 200ms ease-in-out',
      transform: 'translateY(-44px)',
    },
  },
}))

export default useStyles
